import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiAlert = {
  styleOverrides: { root: { fontWeight: 400 }, message: { fontWeight: 400 } },
} satisfies Components<Theme>['MuiAlert'];
